<dialog-header [centered]="true">Send for Review</dialog-header>
<div class="tw-px-[24px]">
  <p class="tw-text-center tw-mb-[32px]">
    The Publisher will review this presentation, and will either publish it, or
    request changes. You will be notified by email.
  </p>
  <search-filter
    [filterConfig]="filterConfig"
    [search]="search"
    [doSearch]="users.doSearch"
  ></search-filter>
</div>
<mat-dialog-content class="tw-overflow-y-auto">
  <div
    class="scrollable-list tw-max-h-full"
    scrollingList
    (scrollEndEvent)="users.load()"
    rvSpinner="company-users-list"
    [rvShowSpinner]="users.loadingItems"
  >
    <table class="table tw-table-fixed tw-w-full">
      <thead class="table-header">
        <tr class="table-header__row">
          <th class="table-header__cell u_clickable">Username</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for (user of users.items.list; track user) {
          <tr class="table-body__row">
            <td
              class="table-body__cell flex-row u_clickable"
              [ngClass]="{ selected: userSelected(user.id) }"
              (click)="toggleUser(user.id)"
            >
              <mat-checkbox
                class="mr-0"
                [ngModel]="userSelected(user.id)"
              ></mat-checkbox>
              <p class="list-group-item-text">
                <strong>{{ user.firstName }} {{ user.lastName }}</strong
                ><small class="text-muted ml-2">{{ user.email }}</small>
              </p>
            </td>
          </tr>
        }
        @if (!users.loadingItems && users.items.list.length === 0) {
          <tr class="table-body__row">
            <td class="table-body__cell">
              <p class="list-group-item-text">No assignable users</p>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<div class="form-group tw-px-[24px]">
  <label class="tw-font-medium" for="comment">Comment (optional)</label>
  <textarea
    id="comment"
    matInput
    rows="3"
    [(ngModel)]="commentFormControl"
    placeholder="Add any notes or instructions for the Publisher."
    class="form-control comments"
  ></textarea>
</div>
<mat-dialog-actions align="end">
  <button matButton="outlined" [mat-dialog-close]="null">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!result.reviewerIds.length"
    [mat-dialog-close]="result"
  >
    Send for Review
  </button>
</mat-dialog-actions>
